const content = {
  DYB: {
    alertLandingPageHeader:
      "B's handy alerts help you stay in control and keep track of your money.",
    alertLandingPageInfo:
      "Text alerts will be sent to {contactNumber}. Not your number? Get in touch with the team at B on 0800 121 7365.  Switched on notifications? These will pop up on your mobile device - even if you're not logged into B.",
    alertLandingPageFooter: 'Alerts are only available for the accounts shown above right now.',
    sweepsPageFooter:
      "Remember this will only work if there's enough money in your savings account.",
    alertSinglePageFooter: 'Alerts are only available for this account right now.',
    noNumberHeader: 'The team at B need your number',
    infoCardContent: 'To get that sorted, get in touch with the team on 0800 121 7365.',
    infoCardContentBusinessCustomer:
      'To get that sorted, get in touch with the team on 0800 121 4209.',
    btnName: 'OK, got it',
    noContactPageText1:
      "For privacy and security reasons, text alerts can only be sent to mobile phones – and it looks like the team at B don't have your mobile number yet.",
    noContactPageText2: "Not got a mobile phone? You won't be able to set up or get text alerts.",
    cancel: 'Cancel',
    confirm: 'Confirm',
    CMATitle: 'Take Action Alerts ',
    CMATextBody:
      "Send me an alert when I don't have enough money in my account to cover a payment or if a payment takes me into an unwarranted overdraft.",
    handyAlerts: 'Other handy alerts',
    CMAModalHeader: 'Sure you want to switch this off?',
    CMAModalInfoCard:
      "It's totally up to you - but you might be more likely to get charges if you do.",
    CMAModalPrimaryBtn: 'Yes, switch them off',
    CMAModalSecondaryBtn: 'No, keep them on',
    WBATitle: 'Weekly balance alerts',
    WBABodyText: "Send me an alert once a week to let me know how much I've got in my account.",
    errorInfo: 'We were unable to load your alerts or sweeps at this time.',
    retryBtn: 'Retry',
    alerts: 'Alerts',
    sweepInfoText:
      "Send me an alert when my account goes below a certain amount and money's automatically moved into it.",
    sweepTitle: 'Sweep alert ',
    sweepHeading: 'Sweep alerts',
    sweepRevealTitleText: 'More information',
    sweepText:
      "Make sure you're always in the black by automatically moving cash between accounts when you're running low.",
    sweepToAccountText: "When I've got less than",
    sweepFromAccountText: 'Sweep money from',
    amountDeductFrom: 'To take me back up to',
    poundSign: '£',
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    highAlertInfoText: "Send me an alert when I've got more than a set amount in my account.",
    lowAlertInfoText: "Send me an alert when I've got less than a set amount in my account. ",
    projectionAlertToggleText:
      'Send me an alert when my account balance is projected to be less than',
    highAlertToggleText: 'Send me an alert when my account balance is more than',
    lowAlertToggleText: 'Send me an alert when my available balance goes below',
    WBAAlertToggleText: "Send me an alert to let me know how much I've got in my account every",
    projectionInfoText:
      'Send me an alert when my account balance is projected to be less than a set amount.',
    lowAlertTitle: 'Low balance alert',
    highAlertTitle: 'High balance alert',
    projectionTitle: 'Projected low balance alert',
    CMAInfoText:
      "These alerts will let you know when you'll have to pay money in for the payment to go through and to stay clear of possible charges. Want to turn them off? That's totally up to you – but you might be more likely to get charges if you do.",
    sweepsInfoText:
      "If your B Current account goes below a certain amount, Sweeps can help you avoid charges by automatically moving money into it from your B Instant Savings account.The lowest amount that can be swept from your savings is £100 so you'll need at least that amount in your B Instant Savings account. Make sense?Sweeps can happen several times a day, even if it's the weekend. And each time, you'll get an alert to let you know what's happening. You can also change your settings here at any time.",
    noContactPageTitle: 'Manage alerts',
    transactionInfoText:
      "Don't worry – you'll only get one alert if a transaction triggers more than one of your chosen options.",
    transactionPageHeader:
      'Stay in control of your money and protect against fraud with real-time transaction alerts.',
    transactionAmountTitle: 'Transaction amount',
    transactionMountToggleText:
      'Send me an alert when my card is used for transactions over a set amount.',
    transactionAmountText: 'Send me an alert when my card is used for transactions over',
    abroadTitle: 'Transaction abroad ',
    abroadTextBody: 'Send me an alert when my card is used outside the UK.',
    abroadInfoText:
      "For security reasons, it's worth keeping this option switched on even when you're abroad. You may also want to ",
    abroadHyperLinkText: "tell us when you're going abroad.",
    abroadInforamationText:
      "This alert will be triggered by physically using your card abroad. It won't be triggered by buying something online (whether you're abroad or in the UK).Want an alert when you buy something online? Simply switch transaction method alerts on.",
    abroadInfoTitle: 'Good to know',
    transactionHeading: 'Transaction alerts',
    amountConfirmText: 'Confirm amount',
    accountSelectionHeading: 'Manage alerts for',
    posText: 'Contactless, Chip and PIN, Swipe',
    posTitle: 'Using a card reader',
    internetTitle: 'Online',
    atmTitle: 'At the ATM',
    methodManualTitle: 'Over the phone or by mail',
    transactionMethodToggleText:
      "Send me an alert when my card is used to make certain transactions, like when it's used online.",
    transactionMethodText: 'Send me an alert when my card is used outside the UK',
    transactionMethodTitle: 'Transaction method',
    thresholdValidationMsg: "Oops. You'll have to enter an amount to continue",
    targetValidationMsg: 'Oops. There as to be at least £100 between each account.',
    alertValidationMsg: "Oops. You'll have to enter an amount here to continue.",
    projectionValidationMsg: "Oops. You'll have to enter an amount here to continue.",
    savingAccountsList: 'Your saving accounts',
    savingAccountSelection: 'From',
    transactionAlertsHeader:
      'Stay in control of your money and protect against fraud with real-time transaction alerts',
    abroadPopupHeading: 'Opening in new window',
    abroadPopupConetnt:
      "This link will open in a new window or tab and will take you out of internet banking. If you like what you see and don't come back in 10 minutes, you'll be automatically logged out.",
    continueText: 'Continue',
    leavePopupHeader: "Your changes haven't been made yet",
    leavePopupContent:
      "If you leave now, your changes won't be made and your alerts won't be updated.",
    leavePopupPrimaryBtnName: 'Review and confirm changes',
    leavePopupSecondaryBtnName: 'Cancel changes',
    confirmMethodPopupHeader: 'An alert about your alerts',
    confirmMethodPopupContent:
      "Switching on these alerts will help keep track of your money and protect against fraud. But it does mean you'll get an alert every time a card is used on your account for your chosen transaction method. Don't worry though – you'll only get one alert if a transaction triggers more than one of your chosen options and you can always change your settings at any time.",
    confirmMethodPopupBtnName: 'OK, got it',
    arrangedOverdraftTextBody:
      'Send me a text when a payment takes my account into my arranged overdraft.',
  },

  CYB: {
    alertLandingPageHeader: 'Our useful alerts help you manage your money and stay in control.',
    alertLandingPageInfo:
      "Text alerts will be sent to {contactNumber}. If this isn't your number, please give us a call on 0800 085 2147. If you've switched on notifications, these will appear on your mobile device - even if you're not logged into the app.",
    alertSMELandingPageInfo:
      "Text alerts will be sent to {contactNumber}. If this isn't your number, please get in touch.",
    alertLandingPageFooter: 'Alerts are currently only available for the accounts shown above.',
    alertSinglePageFooter: 'Alerts are only available for this account right now.',
    noNumberHeader: "We'll need your mobile number",
    infoCardContent:
      "As we don't currently have your number, please give us a call on 0800 121 7365 so we can get your details updated.",
    infoCardContentBusinessCustomer:
      "As we don't currently have your number, please give us a call on 0800 121 4209 so we can get your details updated.",
    btnName: 'OK',
    noContactPageText1:
      'For privacy and security reasons, text alerts can only be sent to mobile phones.',
    noContactPageText2:
      "If you don't have a mobile phone, you won't be able to set up or get text alerts.",
    cancel: 'Cancel',
    confirm: 'Confirm',
    CMATitle: 'Take Action Alerts',
    CMATextBody:
      "Send me an alert when I don't have enough money in my account to cover a payment or if a payment takes me into an unwarranted overdraft.",
    handyAlerts: 'Other useful alerts',
    CMAModalHeader: 'Are you sure you want to switch this off? ',
    CMAModalInfoCard:
      "It's entirely your choice - but you might be more likely to get charges if you do.",
    CMAModalPrimaryBtn: 'Yes, turn them off',
    CMAModalSecondaryBtn: 'No, keep them on',
    WBATitle: 'Weekly balance alerts',
    WBABodyText: "Send me an alert once a week to let me know how much I've got in my account.",
    errorInfo: 'We were unable to load your alerts at this time.',
    retryBtn: 'Retry',
    alerts: 'Alerts',
    sweepText:
      "Make sure you're always in the black by automatically moving cash between accounts when you're running low.",
    sweepFromAccountText: 'Sweep money from',
    amountDeductFrom: 'To take me back up to',
    poundSign: '£',
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    highAlertInfoText: 'Send me an alert when my available balance goes above a set amount.',
    lowAlertInfoText: 'Send me an alert when my available balance goes below a set amount.',
    highAlertToggleText: 'Send me an alert when my available balance goes above',
    lowAlertToggleText: 'Send me an alert when my available balance goes below',
    WBAAlertToggleText: "Send me an alert to let me know how much I've got in my account every",
    lowAlertTitle: 'Low balance alert',
    highAlertTitle: 'High balance alert',
    projectionTitle: 'Projection low Balance alert',
    CMAInfoText:
      "Take action alerts will let you know when you'll have to pay money in to your account for the payment to go through and to avoid possible charges. You can turn these alerts off at any time but you may be more likely to receive charges if you do.",
    noContactPageTitle: 'Manage alerts',
    transactionInfoText:
      "Don't worry – you'll only get one alert if a transaction triggers more than one of your chosen options.",
    transactionPageHeader:
      'Stay in control of your money and protect against fraud with real-time transaction alerts.',
    transactionAmountTitle: 'Transaction amount',
    transactionMountToggleText:
      'Send me an alert when my card is used for transactions over a set amount.',
    transactionAmountText: 'Send me an alert when my card is used for transactions over',
    abroadTitle: 'Transaction abroad ',
    abroadTextBody: 'Send me an alert when my card is used outside the UK.',
    abroadInfoText:
      "For security reasons, it's worth keeping this option switched on even when you're abroad. You may also want to ",
    abroadHyperLinkText: "tell us when you're going abroad.",
    abroadInfoTitle: 'Good to know',
    abroadInforamationText:
      "This alert will be triggered by physically using your card abroad. It won't be triggered by buying something online (whether you're abroad or in the UK).If you want to receive an alert when you buy something online, simply switch transaction method alerts on.",
    transactionHeading: 'Transaction alerts',
    amountConfirmText: 'Confirm amount',
    accountSelectionHeading: 'Manage alerts for',
    posText: 'Contactless, Chip and PIN, Swipe',
    posTitle: 'Using a card reader',
    internetTitle: 'Online',
    atmTitle: 'At the ATM',
    methodManualTitle: 'Over the phone or by mail',
    transactionMethodToggleText:
      "Send me an alert when my card is used to make certain transactions, like when it's used online.",
    transactionMethodText: 'Send me an alert when my card is used outside the UK',
    transactionMethodTitle: 'Transaction method',
    findOutMore: 'Find out more',
    alertValidationMsg: 'Please enter an amount to continue.',
    transactionAlertsHeader:
      'Stay in control of your money and protect against fraud with real-time transaction alerts',
    abroadPopupHeading: 'Opening in new window',
    abroadPopupConetnt:
      "This link will open in a new window or tab and will take you out of internet banking. If you don't return within 10 minutes, you'll be automatically logged out.",
    continueText: 'Continue',
    leavePopupHeader: "Your changes haven't been made yet",
    leavePopupContent:
      "If you leave now, your changes won't be made and your alerts won't be updated.",
    leavePopupPrimaryBtnName: 'Review and confirm changes',
    leavePopupSecondaryBtnName: 'Cancel changes',
    confirmMethodPopupHeader: 'Before you switch on transaction alerts',
    confirmMethodPopupContent:
      "Switching on transaction alerts will help you stay in control of your money and protect you against fraud. But it does mean you'll get an alert every time a card is used on your account for your chosen transaction method. Don't worry though – you'll only get one alert if a transaction triggers more than one of your chosen options. And if you want to edit your transaction alerts, you can change your settings at any time.",
    confirmMethodPopupBtnName: 'OK',
    transactionAmountToggleTextSME:
      'Send me an alert when a transaction over a set amount (at least £100) goes into my account.',
    transactionAmountEnableTextSME:
      "Send me an alert when a transaction goes into my account that's over",
    incomingTransactionsLabel: 'Incoming transactions',
    outgoingTransactionsLabel: 'Outgoing transactions',
    incomingTransactionsHeading: 'Incoming transaction alerts',
    transactionSME: 'Please enter an amount of at least £100 to continue.',
    arrangedOverdraftTextBody: 'Send me a text when a payment takes me into my arranged overdraft.',
  },

  VM: {
    alertLandingPageHeader:
      'Our handy text alerts help you stay in control and keep track of your money.',
    alertLandingPageInfo:
      'All texts will be sent to {contactNumber}. Changed your number? Call us on 0800 121 7365.',
    alertSMELandingPageInfo:
      "Text alerts will be sent to {contactNumber}. If this isn't your number, please get in touch.",
    alertLandingPageFooter: 'Alerts are only available for the accounts shown above right now.',
    sweepsPageFooter:
      "Remember this will only work if there's enough money in your savings account.",
    alertSinglePageFooter: 'Alerts are only available for this account right now.',
    noNumberHeader: 'We need your number',
    infoCardContent: 'To get that sorted, get in touch with us on 0800 121 7365.',
    infoCardContentBusinessCustomer:
      'To get that sorted, get in touch with the team on 0800 121 4209.',
    btnName: 'OK, got it',
    noContactPageText1:
      "For privacy and security reasons, text alerts can only be sent to mobile phones – and it looks like we don't have your mobile number yet.",
    noContactPageText2: "Not got a mobile phone? You won't be able to set up or get text alerts.",
    cancel: 'Cancel',
    confirm: 'Confirm',
    CMATitle: 'Take action alerts ',
    CMATextBody:
      "Send me an alert when I don't have enough money in my account to cover a payment or if a payment takes me into an unwarranted overdraft.",
    handyAlerts: 'Other handy alerts',
    CMAModalHeader: 'Sure you want to switch this off?',
    CMAModalInfoCard:
      "It's totally up to you - but you might be more likely to get charges if you do.",
    CMAModalPrimaryBtn: 'Yes, switch them off',
    CMAModalSecondaryBtn: 'No, keep them on',
    WBATitle: 'Weekly balance alerts',
    WBABodyText: "Send me an alert once a week to let me know how much I've got in my account.",
    errorInfo: 'We were unable to load your alerts or sweeps at this time.',
    retryBtn: 'Retry',
    alerts: 'Alerts',
    sweepInfoText:
      "Send me an alert when my account goes below a certain amount and money's automatically moved into it.",
    sweepTitle: 'Sweep alert ',
    sweepHeading: 'Sweep alerts',
    sweepRevealTitleText: 'More information',
    sweepText:
      "Make sure you're always in the black by automatically moving cash between accounts when you're running low.",
    sweepToAccountText: "When I've got less than",
    sweepFromAccountText: 'Sweep money from',
    amountDeductFrom: 'To take me back up to',
    poundSign: '£',
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    highAlertInfoText: "Send me an alert when I've got more than a set amount in my account.",
    lowAlertInfoText: "Send me an alert when I've got less than a set amount in my account. ",
    projectionAlertToggleText:
      'Send me an alert when my account balance is projected to be less than',
    highAlertToggleText: 'Send me an alert when my account balance is more than',
    lowAlertToggleText: 'Send me an alert when my available balance goes below',
    WBAAlertToggleText:
      "Send me an alert once a week to let me know how much I've got in my account",
    projectionInfoText:
      'Send me an alert when my account balance is projected to be less than a set amount.',
    lowAlertTitle: 'Low balance alert',
    highAlertTitle: 'High balance alert',
    projectionTitle: 'Projected low balance alert',
    CMAInfoText:
      "These alerts will let you know when you'll have to pay money in for the payment to go through and to stay clear of possible charges. Want to turn them off? That's totally up to you – but you might be more likely to get charges if you do.",
    sweepsInfoText:
      'If your current account goes below a certain amount, Sweeps can help you avoid charges by automatically moving money into it from your eligible savings account. The lowest amount that can be swept from your savings is £100 so you’ll need at least that amount in your savings account. Makes sense? Sweeps can happen several times a day, even if it’s the weekend. And each time, you’ll get an alert to let you know what’s happening. You can also change your settings here at any time.',
    noContactPageTitle: 'Manage alerts',
    transactionInfoText:
      "Don't worry – you'll only get one alert if a transaction triggers more than one of your chosen options.",
    transactionPageHeader:
      'Stay in control of your money and protect against fraud with real-time transaction alerts.',
    transactionAmountTitle: 'Transaction amount',
    transactionMountToggleText:
      'Send me an alert when my card is used for transactions over a set amount.',
    transactionAmountText: 'Send me an alert when my card is used for transactions over',
    abroadTitle: 'Transaction abroad ',
    abroadTextBody: 'Send me an alert when my card is used outside the UK.',
    abroadInfoText:
      "For security reasons, it's worth keeping this option switched on even when you're abroad. You may also want to ",
    abroadHyperLinkText: "tell us when you're going abroad.",
    abroadInforamationText:
      "This alert will be triggered by physically using your card abroad. It won't be triggered by buying something online (whether you're abroad or in the UK).Want an alert when you buy something online? Simply switch transaction method alerts on.",
    abroadInfoTitle: 'Good to know',
    transactionHeading: 'Transaction alerts',
    amountConfirmText: 'Confirm amount',
    accountSelectionHeading: 'Manage alerts for',
    posText: 'Contactless, Chip and PIN, Swipe',
    posTitle: 'Using a card reader',
    internetTitle: 'Online',
    atmTitle: 'At the ATM',
    methodManualTitle: 'Over the phone or by mail',
    transactionMethodToggleText:
      "Send me an alert when my card is used to make certain transactions, like when it's used online.",
    transactionMethodText: 'Send me an alert when my card is used outside the UK',
    transactionMethodTitle: 'Transaction method',
    findOutMore: 'Find out more',
    thresholdValidationMsg: "Oops. You'll have to enter an amount to continue",
    targetValidationMsg: 'Oops. There as to be at least £100 between each account.',
    alertValidationMsg: "Oops. You'll have to enter an amount here to continue.",
    projectionValidationMsg: "Oops. You'll have to enter an amount here to continue.",
    savingAccountsList: 'Your saving accounts',
    savingAccountSelection: 'From',
    transactionAlertsHeader:
      'Stay in control of your money and protect against fraud with real-time transaction alerts',
    abroadPopupHeading: 'Opening in new window',
    abroadPopupConetnt:
      "This link will open in a new window or tab and will take you out of internet banking. If you like what you see and don't come back in 10 minutes, you'll be automatically logged out.",
    continueText: 'Continue',
    leavePopupHeader: "Your changes haven't been made yet",
    leavePopupContent:
      "If you leave now, your changes won't be made and your alerts won't be updated.",
    leavePopupPrimaryBtnName: 'Review and confirm changes',
    leavePopupSecondaryBtnName: 'Cancel changes',
    confirmMethodPopupHeader: 'An alert about your alerts',
    confirmMethodPopupContent:
      "Switching on these alerts will help keep track of your money and protect against fraud. But it does mean you'll get an alert every time a card is used on your account for your chosen transaction method. Don't worry though – you'll only get one alert if a transaction triggers more than one of your chosen options and you can always change your settings at any time.",
    confirmMethodPopupBtnName: 'OK, got it',
    arrangedOverdraftTextBody:
      'Send me a text when a payment takes my account into my arranged overdraft.',
    transactionAmountToggleTextSME:
      'Send me an alert when a transaction over a set amount (at least £100) goes into my account.',
    transactionAmountEnableTextSME:
      "Send me an alert when a transaction goes into my account that's over",
    transactionSME: 'Please enter an amount of at least £100 to continue.',
    incomingTransactionsLabel: 'Incoming transactions',
    outgoingTransactionsLabel: 'Outgoing transactions',
    incomingTransactionsHeading: 'Incoming transaction alerts',
  },
};
/* eslint-enable max-len */

export default content;

export const getContent = (brandId) => {
  switch (brandId) {
    case 'B':
      return content.DYB;

    case 'VM':
      return content.VM;

    default:
      return content.CYB;
  }
};
